module.exports = __webpack_public_path__ + "img/13-bd47f0.png";